export const PLAYERS_REFERENCE = {
  SOURCE_UI: {
    HLS: 'hls_player',
    SLDP: 'sldp_player',
    WEBSOCKET: 'websocket_player',
    HTML5: 'html5_player',
    FLV: 'flv_player',
  },
  PROTOCOL: {
    HLS: 'hls',
    SLDP: 'sldp',
    WEBSOCKET: 'websocket',
    HTML5: 'html5',
    FLV: 'flv',
    UNKNOWN: 'unknown',
  },
} as const;
